(function () {
  function initPopup(root) {
    if (!root || root.dataset.wxPopupReady === '1') return;
    root.dataset.wxPopupReady = '1';

    var key = root.getAttribute('data-storage-key') || 'wx-popup-dismissed';
    var days = parseInt(root.getAttribute('data-days'), 10) || 7;
    var delay = parseInt(root.getAttribute('data-delay'), 10);
    if (isNaN(delay)) delay = 1500;

    var dialog = root.querySelector('[data-wx-popup-dialog]');
    var closers = root.querySelectorAll('[data-wx-popup-close]');
    var success = root.querySelector('[data-wx-popup-success]');
    var lastFocus = null;

    function isDismissed() {
      try {
        var raw = localStorage.getItem(key);
        if (!raw) return false;
        var until = parseInt(raw, 10);
        if (!until) return false;
        if (Date.now() > until) {
          localStorage.removeItem(key);
          return false;
        }
        return true;
      } catch (e) {
        return false;
      }
    }

    function persistDismiss() {
      try {
        localStorage.setItem(key, String(Date.now() + days * 24 * 60 * 60 * 1000));
      } catch (e) {}
    }

    function openPopup() {
      if (isDismissed()) return;
      // Wait while the clearance popup is open so the two never stack.
      var clearance = document.querySelector('[data-jwyn-clearance]');
      if (clearance && !clearance.hidden) {
        setTimeout(openPopup, 1000);
        return;
      }
      lastFocus = document.activeElement;
      root.hidden = false;
      document.body.classList.add('wx-popup-open');
      var focusable = root.querySelector('input, button, [href]');
      if (focusable) focusable.focus();
    }

    function closePopup(save) {
      root.hidden = true;
      document.body.classList.remove('wx-popup-open');
      if (save) persistDismiss();
      if (lastFocus && typeof lastFocus.focus === 'function') lastFocus.focus();
    }

    closers.forEach(function (el) {
      el.addEventListener('click', function () {
        closePopup(true);
      });
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !root.hidden) closePopup(true);
    });

    if (success) {
      persistDismiss();
      openPopup();
      return;
    }

    if (isDismissed()) return;

    setTimeout(openPopup, Math.max(0, delay));
  }

  function boot() {
    document.querySelectorAll('[data-wx-popup]').forEach(initPopup);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target && (e.target.matches('[data-wx-popup]') ? e.target : e.target.querySelector('[data-wx-popup]'));
    if (root) {
      delete root.dataset.wxPopupReady;
      initPopup(root);
    }
  });
})();
